import { ZUid } from "src/types/zUid";

export const userPreferenceKeys = {
  enitiesSearchLP: (objectId: ZUid) => `enitiesSearchLP-${objectId}`,
  enitiesSearchState: (objectId: ZUid) => `enitiesSearchState-${objectId}`,
  childEntities: (objectId: ZUid) => `childEntities-${objectId}`,
  entityTableSettings: (objectId: ZUid) => `entityTableSettings-${objectId}`,
} as const;
